module.exports = __webpack_public_path__ + "static/media/Tinder.28a1ba6d.png";